"use-client";

import {
  CalendarIcon,
  ChatIcon,
  FollowIcon,
  FollowingIconV2,
  HandShakeIcon,
  HandShakeSimpleIcon,
  VerticalThreeDot,
} from '@mybridge/icons';
import { FollowersIcon } from '@mybridge/icons/Followers';
import { MeetingDefaultIcon } from '@mybridge/icons/NotificationIcons';
import { CloseButton, Divider, IconButton, Link, Text, Tooltip } from '@mybridge/ui';
import { Avatar } from '@mybridge/ui/avatar';
import { Button } from '@mybridge/ui/button';
import { Box, Center, Container, HStack, Stack, VStack } from '@mybridge/ui/layout';
import { MatrixContext } from 'packages/mybridgev4/context/chat-context';
import { useContext, useState } from 'react';
import { MyNetworkContext } from 'v4/components/network/context';
import { PublicProfileContext } from 'v4/components/public-profile/context';
import {
  formatLocation,
  getUserEducation,
  getUserEducationSpan,
  getUserExperience,
  getUserExperienceSpan,
  getUserFullName,
  getUserProfilePic,
} from 'v4/lib/commons';
import { GlobalContext } from 'v4/snippets/global/context';
import './banner.module.scss';
import { PublicProfileMenu } from './menu';
import { useSelector, useDispatch } from 'react-redux';
import { scheduleMeetingWithUser } from 'v4/store/actions/meeting.actions';
import { useRouter } from 'next/router';
import { isMobile } from 'react-device-detect';
import RightProfileActionsPublic from './right-profile-actions';
import { MyNetworkProvider } from 'v4/components/network/context';
import { Flex } from '@chakra-ui/react';
import Image from 'next/image';
import { ForceSignInWrapper } from 'v4/components/force-sign-in-wrapper';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
export const Banner = () => {
  const {
    allDegreeConnectionsArr,
    userProfileInfo,
    publicProfile,
    experiences,
    educations,
    isInCircle,
    loggedIn,
    isHandshaked,
    isHandshakeRequested,
    isFollowed,
    isFriend,
    actions,
  } = useContext(PublicProfileContext);
  const [selectedFeeling, setSelectedFeeling] = useState();
  const { t } = useTranslator();
  const direction = useDirection();
  const { feelingsAndActivities } = useSelector((s) => s.globalData) ?? {};
  const { followUser, followLoading, unfollowUser, handshakeUser } =
    useContext(MyNetworkContext);
  const { startMeetingSingle, startChatSingle } = useContext(MatrixContext);
  const { openImagePopup } = useContext(GlobalContext);
  const { profile_banner_pic, feelings_activity, matrix_user_id, connect_count, follow_count } =
    publicProfile ?? {};
  const userName = getUserFullName(publicProfile);
  const userProfilePic = getUserProfilePic(publicProfile);
  const userEducation = getUserEducation({ educations });
  const userExperience = getUserExperience({ experiences });
  const eduSpan = getUserEducationSpan({ educations });
  const expSpan = getUserExperienceSpan({ experiences });
  let userLocation = formatLocation(publicProfile);
  let userExperienceLocation = formatLocation(userExperience);
  userLocation = userLocation?.length ? userLocation : publicProfile?.location;
  const circle = [];
  const followers = [];
  const profileReport = true
  const router = useRouter();
  const dispatch = useDispatch();
  // console.log(publicProfile);

  const handleStartChatClick = (e) => {
    startChatSingle(publicProfile);
  };

  const handleMeetNowClick = (e) => {
    startMeetingSingle(publicProfile);
  };

  const handleScheduleMeeting = () => {
    dispatch(
      scheduleMeetingWithUser({ users: publicProfile, type: 'connection' })
    );
    router.push('/profile/calendar/schedule');
  };
  const startDate =
    userExperience?.start_month === '0'
      ? `Jan ${userExperience?.start_year}`
      : `${new Date(
        userExperience?.start_year,
        userExperience?.start_month - 1,
        1
      ).toLocaleString('default', { month: 'short' })} ${userExperience?.start_year
      }`;

  const endDate = userExperience?.currently_working
    ? 'Present'
    : `${new Date(
      userExperience?.end_year,
      userExperience?.end_month - 1,
      1
    ).toLocaleString('default', { month: 'short' })} ${userExperience?.end_year
    }`;
  const bannerPic =
    profile_banner_pic?.length && profile_banner_pic?.includes('/profile')
      ? profile_banner_pic
      : '/nobanner.png';

  const validateStartDate = (Date) => {
    // Check if startDate is undefined or invalid
    if (Date != 'Invalid Date undefined' && /\d/.test(Date)) {
      return true; // Invalid date or undefined
    }
    return false; // Valid startDate and year
  };

  const getFeelingActivityGrammer = (category) => {
    switch (category) {
      case 'More':
        return '';
      case 'Attending':
        return 'Attending ';
      case 'Celebrating':
        return 'Celebrating ';
      case 'Feeling':
        return 'Feeling ';
      default:
        return '';
    }
  };

  // const PublicProfileSideMenu = () => {
  //   return (
  //     <HStack pl={['0', '0', '0']}>
  //       <HStack flex={1}>
  //         {userProfileInfo?.id === publicProfile?.id ? (
  //           <Box minW="140px"></Box>
  //         ) : (
  //           <>
  //             {isFollowed(publicProfile) ? (
  //               <Button
  //                 size="sm"
  //                 variant="secondary"
  //                 borderRadius="full"
  //                 onClick={(e) => unfollowUser(publicProfile)}
  //               >
  //                 Following
  //               </Button>
  //             ) : (
  //               <Button
  //                 onClick={(e) => followUser(publicProfile)}
  //                 isLoading={followLoading}
  //                 size="sm"
  //                 variant="secondary"
  //                 borderRadius="full"
  //               >
  //                 Follow
  //               </Button>
  //             )}
  //           </>
  //         )}
  //       </HStack>
  //       {userProfileInfo?.id === publicProfile?.id ? (
  //         ''
  //       ) : !isFriend?.(publicProfile) ? (
  //         <HStack justifyContent="flex-end">
  //           <Button
  //             variant="primary"
  //             leftIcon={
  //               <HandShakeSimpleIcon width="20" height="20" color="white" />
  //             }
  //             onClick={() => handshakeUser(publicProfile)}
  //           >
  //             Handshake
  //           </Button>
  //         </HStack>
  //       ) : (
  //         <HStack justifyContent="flex-end">
  //           {!isMobile ? (
  //             <>
  //               <Button
  //                 variant="secondary"
  //                 leftIcon={<ChatIcon width="20" height="20" />}
  //                 onClick={handleStartChatClick}
  //               >
  //                 Message
  //               </Button>
  //               <Button
  //                 onClick={handleMeetNowClick}
  //                 variant="secondary"
  //                 leftIcon={<MeetingDefaultIcon width="20" height="20" />}
  //               >
  //                 Meet Now
  //               </Button>
  //               <Button
  //                 variant="secondary"
  //                 leftIcon={<CalendarIcon width="20" height="20" />}
  //                 as={Link}
  //                 onClick={() => handleScheduleMeeting()}
  //               >
  //                 Schedule
  //               </Button>
  //             </>
  //           ) : (
  //             <>
  //               <IconButton
  //                 variant="secondary"
  //                 icon={<ChatIcon width="20" height="20" />}
  //                 onClick={handleStartChatClick}
  //               />
  //               <IconButton
  //                 onClick={handleMeetNowClick}
  //                 variant="secondary"
  //                 icon={<MeetingDefaultIcon width="20" height="20" />}
  //               />
  //               <IconButton
  //                 variant="secondary"
  //                 icon={<CalendarIcon width="20" height="20" />}
  //                 as={Link}
  //                 onClick={() => handleScheduleMeeting()}
  //               />
  //             </>
  //           )}
  //         </HStack>
  //       )}
  //       {userProfileInfo?.id === publicProfile?.id ? (
  //         ''
  //       ) : (
  //         <HStack>
  //           <PublicProfileMenu>
  //             <IconButton
  //               variant="transparent"
  //               p={0}
  //               width="10px"
  //               icon={<VerticalThreeDot width="10" height="20" />}
  //             />
  //           </PublicProfileMenu>
  //         </HStack>
  //       )}
  //     </HStack>
  //   );
  // };
  const handleProfileClick = () => {
    if (userProfilePic?.length && userProfilePic !== "https://cdn.bybk.org/media/" &&  userProfilePic !== "https://cdn.mybridge.me/media/") {
      openImagePopup(userProfilePic, 'user-profile')
    }
  };
  const handleBannerClick = () => {
    if (bannerPic?.length && bannerPic !== "/nobanner.png") {
      openImagePopup(bannerPic, 'banner')
    }
  };
  return (
    <>
      <MyNetworkProvider profileReport={profileReport}>

        <Stack>
          <Container maxW="1250px" p={0}>
            <HStack>
              <Box
                bgImage={bannerPic}
                w="100%"
                h={['200px', '200px', '255px']}
                borderRadius={[0, '8px']}
                bgPosition="center"
                bgSize="cover"
                bgRepeat="no-repeat"
                position="relative"
                display="flex"
                justifyContent="center"
                pos="relative"
                role="group"
                // onClick={(e) => openImagePopup?.(bannerPic, 'banner')}
                onClick={handleBannerClick}
                // _hover={{ opacity: 0.9 }}
                cursor={bannerPic && bannerPic !== "/nobanner.png" ? 'pointer' : 'default'}
              ></Box>
            </HStack>
          </Container>
        </Stack>
        <Container maxW="1220px" p={0} zIndex="1">
          {isMobile ? (
            <VStack alignItems="flex-start">
              <Stack px="10px" mt="-16" direction="row" spacing={1.5} align="center" width='full'>
                <Box pos="relative" >
                  <Avatar
                    cursor="pointer"
                    name={userName}
                    size="2xl"
                    src={userProfilePic}
                    // onClick={(e) => openImagePopup(userProfilePic, 'user-profile')}
                    onClick={handleProfileClick}
                    border="3px solid white"
                  />
                </Box>

                <Flex
                  direction="row"
                  align="center"
                  justify="flex-end"
                  maxW={['none', '237px']}
                  w="full"
                  ml={0}
                  gap="10px" // Space between Button and Menu
                >
                  {loggedIn ? (
                    <>
                      <RightProfileActionsPublic />
                    </>
                  ) : (
                    '')}
                </Flex>

              </Stack>


              <Stack pt="4" flex={1} direction={['column', 'row']} zIndex="1" pl={"25px"}>
                <Stack>
                  <Stack
                    spacing={0}
                    justifyContent="flex-start"
                    alignItems="start"
                  >
                    <Stack spacing={[1, 1, 1]}>
                      <HStack>
                        <Text fontWeight="400" fontSize="20px" color={["#3D5A80", "brandPrimary.500"]}>
                          {userName}
                        </Text>
                        {publicProfile?.is_beta && publicProfile?.beta_status==='completed' && (
                          <Box 
                            bg="orange.100" 
                            borderRadius="full" 
                            px={2} 
                            py={1}
                          >
                            <Text 
                              fontSize="10px" 
                              fontWeight="bold" 
                              color="orange.600"
                              textTransform="uppercase"
                            >
                              Beta
                            </Text>
                          </Box>
                        )}
                      </HStack>
                    </Stack>
                    <Box textAlign="start">
                      {userExperience?.id ? (
                        <>
                          <Text display="inline" color="#868585">
                            {userExperience?.title + ' at '}
                          </Text>
                          <Text display="inline" fontWeight="bold">
                            {userExperience?.company_name}
                          </Text>
                        </>
                      ) : userEducation?.id ? (
                        <>
                          <Text display="inline">Student at </Text>
                          <Text display="inline" fontWeight="bold">
                            {userEducation?.name}
                          </Text>
                        </>
                      ) : (
                        ''
                      )}
                    </Box>
                    <HStack spacing={1} textAlign="start" alignItems="start" display="block" fontSize="12px">
                      <Text color="#868585">
                        {startDate} - {endDate} .
                      </Text>

                      <Text color="#868585">{userLocation}</Text>
                    </HStack>
                    <VStack gap="3">
                      {connect_count ? (
                        <Text color={["#4F4F4F", "blackAlpha.500"]} minW="140px" mt={2}>
                          {connect_count + follow_count} {" "}
                          {connect_count + follow_count === 1
                            ? 'Connection'
                            : 'Connections'}
                        </Text>
                      ) : (
                        <Box minW="140px"></Box>
                      )}
                    </VStack>
                    <Box p="10px 0px">
                      {feelings_activity && (
                        <Box
                          borderRadius="full"
                          px={3}
                          py={2}
                          className="primaryGradiantButton"
                        >
                          <HStack>
                            <Flex
                              width="25px"
                              height="25px"
                              bg="white"
                              borderRadius="full"
                              justifyContent="center"
                              alignItems="center"
                            >
                              <img
                                src={feelings_activity?.file}
                                width="22"
                                height="22"
                              />
                            </Flex>
                            <Text color="#fff" fontSize="14px">
                              {getFeelingActivityGrammer(feelings_activity?.category)}
                              {feelings_activity?.name}
                            </Text>
                            {/* <Center height="14px">
                      <Divider
                        orientation="vertical"
                        borderColor="white"
                        opacity="1"
                      />
                    </Center> */}

                          </HStack>
                        </Box>
                      )}
                    </Box>
                  </Stack>
                </Stack>
              </Stack>
            </VStack>
          ) : (
            <Stack ps="4">
              <HStack>
                <Stack mt="-16">
                  <Box pos="relative">
                    <Avatar
                      // cursor="pointer"
                      // _hover={{ opacity: 0.9 }}
                      name={userName}
                      size={['xl', 'xl', 'doubleXl']}
                      src={userProfilePic}
                      // onClick={(e) => openImagePopup(userProfilePic, 'user-profile')}
                      onClick={handleProfileClick}
                      border="3px solid white"
                    />

                  </Box>
                </Stack>
                <Box
                  position="absolute"
                  top="260"
                  left="175"
                  p={3} // Add padding if needed
                  zIndex="2" // Ensure it appears above other elements
                >
                  {feelings_activity && (
                    <Box
                      borderRadius="full"
                      pl={1}
                      pr={2}
                      py={1}
                      className="primaryGradiantButton"
                    >
                      <HStack>
                        <Flex
                          width="25px"
                          height="25px"
                          bg="white"
                          borderRadius="full"
                          justifyContent="center"
                          alignItems="center"
                        >
                          <img
                            src={feelings_activity?.file}
                            width="22"
                            height="22"
                          />
                        </Flex>
                        <Text color="#fff" fontSize="14px">
                          {getFeelingActivityGrammer(feelings_activity?.feeling_category)}
                          {feelings_activity?.name}
                        </Text>
                        {/* <Center height="14px">
                      <Divider
                        orientation="vertical"
                        borderColor="white"
                        opacity="1"
                      />
                    </Center> */}

                      </HStack>
                    </Box>
                  )}
                </Box>
                <Box
                  position="absolute"
                  top="255"
                  // right="-30"
                  {...(direction === 'rtl') ? {left:"-30"} : {right:"-30"}}
                  p={3} // Add padding if needed
                  zIndex="2" // Ensure it appears above other elements
                >
                  {connect_count > 0 ? (
                    <Text color="#868585" fontSize='14px' fontWeight={400} {...(direction === 'rtl') ? {minW: "100px"} : {minW: "140px"}}>
                      {connect_count + follow_count}{' '}
                      {connect_count + follow_count === 1
                        ? t('profile.connection') || 'Connection'
                        : t('profile.connections') || 'Connections'}
                    </Text>
                  ) : (
                    <Box {...(direction === 'rtl') ? {minW: "100px"} : {minW: "140px"}}></Box>
                  )}
                </Box>
              </HStack>
              <HStack
                // justifyContent={['center', 'flex-start', 'left']}
                {...(direction === 'rtl') ? {justifyContent: ['center', 'flex-start', 'right']} : {justifyContent: ['center', 'flex-start', 'left']}}
                zIndex="1"
              >
                <HStack gap="30px">
                  <Stack pt="4" flex={1} direction={['column', 'row']} zIndex="1" >
                    <Stack>
                      <Stack spacing={0}>
                        <Stack spacing={[1, 1, 1]}>
                          <HStack>
                            <Text
                              fontWeight="400"
                              color="#3D5A80"
                              fontSize="30px"
                              marginTop='0px'
                            >
                              {userName}{' '}
                              {publicProfile?.pronouns && !publicProfile?.pronouns.includes(null)
                                ? `(${publicProfile?.pronouns})`
                                : ``}
                            </Text>
                            {publicProfile?.is_beta && publicProfile?.beta_status==='completed' && (
                              <Box 
                                bg="orange.100" 
                                borderRadius="full" 
                                px={2} 
                                py={1}
                              >
                                <Text 
                                  fontSize="12px" 
                                  fontWeight="bold" 
                                  color="orange.600"
                                  textTransform="uppercase"
                                >
                                  Beta
                                </Text>
                              </Box>
                            )}
                          </HStack>
                        </Stack>
                        <Box>
                          {userExperience?.id ? (
                            <>
                              <Text display="inline">
                                {userExperience?.title + ' at '}
                              </Text>
                              <Text display="inline" fontWeight="bold">
                                {userExperience?.company_name}
                              </Text>
                            </>
                          ) : userEducation?.id ? (
                            <>
                              <Text display="inline">Student at </Text>
                              <Text display="inline" fontWeight="bold">
                                {userEducation?.name}
                              </Text>
                            </>
                          ) : (
                            ''
                          )}
                        </Box>
                        <HStack>
                          {validateStartDate(startDate) && (
                            <Text color="blackAlpha.600" fontSize="sm">
                              {startDate} - {endDate}
                            </Text>
                          )}
                          {validateStartDate(startDate) && (
                            <Text color="blackAlpha.600" fontSize="2xl">
                              ·
                            </Text>
                          )}
                          <Text color="#868585" fontSize="14px" fontWeight={400}>
                            {userLocation || userExperience?.location || userExperienceLocation}
                          </Text>

                        </HStack>

                        {/* Logout Icon options */}
                        <Box ml={-19}>
                          {loggedIn ? (
                            ''
                          ) : (
                            <RightProfileActionsPublic />
                          )}
                        </Box>

                      </Stack>
                    </Stack>


                  </Stack>



                </HStack>



              </HStack>
            </Stack>
          )}
          {loggedIn && !isMobile ? (
            <>
              <RightProfileActionsPublic />
            </>
          ) : (
            ''
          )}
        </Container>
      </MyNetworkProvider>
    </>
  );
};
export default Banner;
